export default __webpack_public_path__ + "static/media/telco-button.02b939f0.png";